<template>
  <div class="popup-form">
    <div class="content-form-popup">
      <div class="header-text">
        <div class="back-button-wrapper pointer" @click="closePopup">
          <img class="nav-link-icon filter-primary" src="@/images/modal-close.svg" alt=""/>
        </div>
        <div class="blackcolor pop-800">Výber lokality</div>
      </div>
      <div
        class="popup-block d-flex justify-content-start pointer align-items-center"
        v-for="(district, index) in this.districtChoices" :key="index"
        @click="toggleDistrict(district.id)"
      >
        <div class="checkboxWrapper">
          <img v-if="isDistrictPicked(district.id)"
               alt=""
               class="nav-link-icon extrasmall filter-primary"
               loading="lazy" src="https://cdn.prod.website-files.com/648b04f9d8e52d9524912b4a/692aede6bc96dc77105a6e88_checkiconsimple.svg"/>
        </div>
        <div class="cta-email">
          {{ district.name }}
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import {mapGetters} from "vuex";

export default {
  name: "BrokerDistrictPickerPopUp",
  props: {
    payload: Object,
  },
  computed: {
    ...mapGetters({
      formByType: "formStore/getFormByType"
    }),

    districtChoices() {
      const districts = this.formByType("districtChoices");
      return districts.filter((d) => d.region === this.payload.region);
    }
  },
  mounted() {
    this.districtsPicked = this.payload.districtsServed;
  },
  methods: {
    toggleDistrict(districtId) {
      if (this.isDistrictPicked(districtId)) {
        const index = this.districtsPicked.indexOf(districtId);
        if (index !== -1) {
          this.districtsPicked.splice(index, 1);
        }
      } else {
        this.districtsPicked.push(districtId);
      }
    },

    closePopup() {
      this.$store.commit("popupManagerState/popItemFromPopupOrder");
    },

    isDistrictPicked(districtId) {
      return this.districtsPicked.includes(districtId);
    },
  },
  data: () => ({
    districtsPicked: [],
  })
}
</script>

<style scoped>

</style>